"use client"

import { ShareBar } from "@/components/data/share-bar"

interface ToolShareBarProps {
  /** The tool title / headline to include in the share copy */
  title: string
  /** Optional explicit URL. Defaults to `window.location.href` at click-time. */
  url?: string
  /** The actual page image to include when a visitor saves it to Pinterest. */
  imageUrl?: string
  /** Additional classes on the outer wrapper */
  className?: string
  /** utm_campaign value for this surface. Defaults to 'tool'. */
  utmCampaign?: string
  /** WHAT is being shared, for the buttons' title/aria-label (FRIDGE-352).
   *  Defaults to `title` inside ShareBar. */
  subject?: string
}

/**
 * ToolShareBar — compact inline share row for tool-page (and local-page) heroes.
 *
 * Thin wrapper over the shared `ShareBar` so tool, local, and rebate heroes show
 * the SAME full share rail in the SAME official full-color icon style (owner
 * spec 07/20 — the logo is the button, always colorful, one line):
 * X, Facebook, LinkedIn, Pinterest, Reddit, WhatsApp, Telegram, email, copy, and
 * native Web Share. The prop signature is unchanged so every caller compiles.
 */
export function ToolShareBar({ title, url, imageUrl, className = "", utmCampaign = "tool", subject }: ToolShareBarProps) {
  return (
    <ShareBar
      title={title}
      pageUrl={url}
      imageUrl={imageUrl}
      variant="compact"
      label="Share"
      subject={subject}
      utmCampaign={utmCampaign}
      utmContent="tool-share"
      className={className}
    />
  )
}
